import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactScanDialogComponent } from './dialog/contact-scan';
import { AppService } from 'app/app.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FuseContactScanService {
    constructor(
        private appService: AppService,
        private http: HttpClient,
        private _matDialog: MatDialog
    ) { }

    open(data: any = {}, config: any = {}): any {
        const defaultConfig = {
            width: '500px',
            // Add other default configuration options here
        };

        return this._matDialog.open(ContactScanDialogComponent, {
            ...defaultConfig,
            ...config,
            data: data
        });
    }

    contactScanner(image: File) {
        const formData = new FormData();
        formData.append('image', image);

        return this.http.post(
            this.appService.getApiUrl() + 'service/contact-scanner',
            formData
        );
    }
}
